import React from 'react';

import ReviewCarousel from '../../Review/Carousel/ReviewCarousel';

import { Flex } from '../../../components/common/atom/Layout';
import { Image } from '../../../components/common/atom/Image';
import { Video } from '../../../components/common/atom/Video';
import { Picture } from '../../../components/common/molecules/Picture';
import { STORY } from '../../../components/common/template/PDPTemplate';

import {
  BABYFACE_DETAIL_IMAGES,
  BABYFACE_DETAIL_GIFS,
} from '../../../lib/image/ServiceImages';


const BabyfaceSalesMenu = () => {

  return (
    <>
      <Flex
        column
        padding="1.25rem"
        id={STORY}
        style={{ position: 'relative' }}
      >
        {BABYFACE_DETAIL_IMAGES.map((image, idx) =>
          image.poster ? (
            <Video
              key={image.alt}
              style={{ marginTop: '2rem' }}
              src={image.src}
              alt={image.alt}
              poster={image.poster}
            />
          ) : (
            <Picture key={`image_${idx}`} image={image} />
          ),
        )}
        {BABYFACE_DETAIL_GIFS.map((gif, idx) => (
          <Image
            src={gif.src}
            alt={gif.alt}
            key={`gif_${idx}`}
            style={gif.style}
          />
        ))}
      </Flex>
      <ReviewCarousel />
    </>
  );
};


export default BabyfaceSalesMenu;
